<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="page">
    <scroll-view class="mainScrollView">
      <div class="topBg" :style="{ height: sHeight + 'px' }">
        <!-- <div class="iconT"></div> -->
        <div class="icon"></div>
        <div class="title"></div>
        <div class="content"></div>

           
        </div>
        <div class="products" :style="{ height: sHeight + 'px'}">
          <div class="title"></div>
          <div class="img" @mouseover="handleMouseOverProductsImg" @mouseleave="handleMouseLeaveProductsImg"></div>
          
          <!--  -->
        </div>
        <div class="more">
          <div class="email">contact via mail ： cfan0582@gmail.com</div>
         
        </div>
    </scroll-view>
    </div>
</template>

<script>
import $ from  'jquery'
export default {

  data() {
    return {
      sHeight:"",
      sWidth:"",
    };
  },
  mounted() {
     this.sHeight = window.innerHeight; // 屏幕高度 
     this.sWidth = window.innerWidth; // 屏幕宽度 
     console.log("高度",  this.sHeight);    
     console.log("宽度",  this.sWidth);
  },
  methods: {
    handleMouseOverLeft() {
      // 处理鼠标移入的操作
      console.log("鼠标已经移动到了该DIV");
      const targetDiv = document.querySelector('.left');
      targetDiv.style.transform = 'scale(1.1)';
      $(".lTitle").css("font-weight","700");
  },
  handleMouseLeaveLeft(){
    const targetDiv = document.querySelector('.left');
      targetDiv.style.transform = 'scale(1.0)';
      $(".lTitle").css("font-weight","400");
  },
  handleMouseOverCenter() {
      // 处理鼠标移入的操作
      console.log("鼠标已经移动到了该DIV");
      const targetDiv = document.querySelector('.center');
      targetDiv.style.transform = 'scale(1.1)';
      $(".cTitle").css("font-weight","700");
  },
  handleMouseLeaveCenter(){
    const targetDiv = document.querySelector('.center');
      targetDiv.style.transform = 'scale(1.0)';
      $(".cTitle").css("font-weight","400");
  },
  handleMouseOverRight() {
      // 处理鼠标移入的操作
      console.log("鼠标已经移动到了该DIV");
      const targetDiv = document.querySelector('.right');
      targetDiv.style.transform = 'scale(1.1)';
      $(".rTitle").css("font-weight","700");
  },
  handleMouseLeaveRight(){
    const targetDiv = document.querySelector('.right');
      targetDiv.style.transform = 'scale(1.0)';
      $(".rTitle").css("font-weight","400");
  },

  handleMouseOverProductsImg() {
      // 处理鼠标移入的操作
      console.log("鼠标已经移动到了该DIV");
      const targetDiv = document.querySelector('.img');
      targetDiv.style.transform = 'scale(1.1)';
  },
  handleMouseLeaveProductsImg(){
    const targetDiv = document.querySelector('.img');
      targetDiv.style.transform = 'scale(1.0)';
  },
}
};
</script>

<style lang="scss" scoped>
@keyframes backgroundAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

.email {
  animation: blink 1s infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.page{
  .mainScrollView{
    .topBg{
        //  background-color: red;
        background-size: cover;
        align-items: center;
        // justify-content: center;
        display: flex;
        background-image:url('../assets/topbgImage.png');
        background-repeat: no-repeat;
        animation: backgroundAnimation 3s linear; /* 设置动画属性 */
        flex-direction: column;
    
        .icon{
          margin-top: 5%;
          width: 234px;
          height: 232px;
          background-size: 100%;
          align-items: center;
          display: flex;
          background-image:url('../assets/logoIcon.png');
        }
        .title{
          background-image:url('../assets/AIgeniusTitle.png');
          width: 1145px;
          height: 168px;
          margin-top: 80px;
        }
        .content{
           background-image:url('../assets/AIgeniusContent.png');
          width: 1332px;
          height: 264px;
          margin-top: 50px;
        }
        
    }
    .products{
     // background-color: #D7AC3A;
      align-items: center;
        justify-content: center;
        display: flex;
        background-image: url('../assets/productBg.png');
        background-repeat: no-repeat;
        background-size: cover;
      // transition: transform 1.8s ease;
      .title{
        font-size: 30px;
        font-weight: 700;
        color: white;
        // background-color: black;
        text-align: center;
        margin-right: 5%;
      }
      .img{
        
        background-size: 100%;
        background-image: url('../assets/phoneImage.png');
        width: 939px;
        height: 918px;
      background-repeat: no-repeat;
      transition: transform 0.8s ease;
      //  background-color: #1048a0;
       margin-right: 0px;
      }
      
    }
    .more{
      height: 200px;
      // background-color: gray;
      display: flex;
      align-items: center;
      justify-content: center;
      .email{
        color: #3491FD;
        font-weight: 1000;
        font-size: 60px;
      }


    }
  }
    
}

</style>